/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerReadQuery($customerOfCustomerId: ID, $search: String, $take: PositiveInt, $skip: Int) {
  CustomerRead(customerOfCustomerId: $customerOfCustomerId, search: $search, take: $take, skip: $skip, returnDeliveriesOfTrunk: false) {
    id,
    createdAt,
    displayName,
    message,
    overDraftLimit,
    phone,
    status,
    country,
    type,
    _totalCount
    AccountManager {
      displayName
    }
    CustomerOfCustomer {
      id
    }
    CustomerAccount {
      Smpp {
        sourceAddress
      }
      Route {
          displayName,
          RoutePlan {
            Sms {
              id,
              status
            }
          }
        }
    }
    Credit {
      limit,
      balance,
      alertAmount,
      CreditHistory {
        createdAt,
        limit,
        balance,
        alertAmount
      }
    }
    Company {
      displayName,
    }
  }
}
`
